module.exports = __webpack_public_path__ + "static/media/HeaderImage.f2cabd60.svg";